import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {getBuildAgent, getIsSakuraUI} from '../../../../selectors'
import type {AgentPool} from '../../../../services/rest'
import type {AgentPoolId, BuildId} from '../../../../types'

import AgentPoolLink from './AgentPoolLink'

type Props = {
  buildId: BuildId
  className?: string
  secondary?: boolean
}
type AgentPoolProps = {
  name?: string | null | undefined
  poolId?: AgentPoolId
}

const mapAgentPoolToProps = (pool: AgentPool | null | undefined): AgentPoolProps => {
  if (pool == null) {
    // https://github.com/facebook/flow/issues/2977#issuecomment-385169799
    return Object.freeze({})
  }

  const {name, id: poolId} = pool
  return {
    name,
    poolId,
  }
}

const mapStateToProps = (state: State, props: Props) => ({
  ...mapAgentPoolToProps(getBuildAgent(state, props.buildId)?.pool),
  isSakuraUI: getIsSakuraUI(state),
})

export default connect(mapStateToProps, {})(AgentPoolLink)
